var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.debugMode)?_c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_vm._v(_vm._s(_vm.debugText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }